import CannabisLeafIcon from "@/components/CannabisLeafIcon";
import { IMAGES } from "@shared/constants";
import { Link } from "wouter";
import { MapPin, Users, BookOpen, ShoppingCart, Bot } from "lucide-react";

const socialLinks = [
  {
    name: "Instagram",
    href: "https://www.instagram.com/releafa.network?igsh=NmZtcWV6eHl3cjZx",
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
      </svg>
    ),
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/share/17bEQRXARF/",
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
  },
  {
    name: "Threads",
    href: "https://www.threads.com/@releafa.network",
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 192 192">
        <path d="M141.537 88.988a66.667 66.667 0 0 0-2.518-1.143c-1.482-27.307-16.403-42.94-41.457-43.1h-.34c-14.986 0-27.449 6.396-35.12 18.036l13.779 9.452c5.73-8.695 14.724-10.548 21.348-10.548h.229c8.249.053 14.474 2.452 18.503 7.129 2.932 3.405 4.893 8.111 5.864 14.05-7.314-1.243-15.224-1.626-23.68-1.14-23.82 1.371-39.134 15.264-38.105 34.568.522 9.792 5.4 18.216 13.735 23.719 7.047 4.652 16.124 6.927 25.557 6.412 12.458-.683 22.231-5.436 29.049-14.127 5.178-6.6 8.453-15.153 9.899-25.93 5.937 3.583 10.337 8.298 12.767 13.966 4.132 9.635 4.373 25.468-8.546 38.376-11.319 11.308-24.925 16.2-45.488 16.351-22.809-.169-40.06-7.484-51.275-21.742C35.236 139.966 29.808 120.682 29.605 96c.203-24.682 5.63-43.966 16.133-57.317C56.954 24.425 74.204 17.11 97.013 16.94c22.975.17 40.526 7.52 52.171 21.847 5.71 7.026 9.98 15.827 12.737 26.112l16.198-4.323c-3.403-12.556-8.813-23.388-16.161-32.346C147.096 10.645 125.051 1.205 97.07 1h-.113C69.004 1.205 47.199 10.68 32.438 28.17 19.293 43.64 12.449 65.3 12.207 96c.242 30.7 7.086 52.36 20.231 67.83C47.199 181.32 69.004 190.795 96.957 191h.113c24.96-.173 42.554-6.708 57.048-21.189 18.963-18.945 18.392-42.692 12.142-57.27-4.484-10.454-13.033-18.945-24.723-24.553zm-41.99 55.784c-10.426.572-21.258-4.095-21.808-14.082-.395-7.399 5.266-15.652 22.25-16.642 1.949-.112 3.86-.168 5.738-.168 6.107 0 11.822.586 17.018 1.709-1.934 24.117-13.198 28.955-23.198 29.183z"/>
      </svg>
    ),
  },
  {
    name: "X",
    href: "https://x.com/releafanetwork",
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-border/50 bg-card/50 backdrop-blur-sm">
      <div className="container py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-4 lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <img src={IMAGES.logo} alt="RELEAFA NETWORK" className="h-8 w-8 rounded-lg" />
              <span className="text-lg font-bold text-gradient-main">RELEAFA NETWORK</span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed mb-4">
              The cannabis Releafa network. Your all-in-one platform for discovery, community, and wellness.
            </p>
            {/* Contact Info */}
            <div className="flex flex-col gap-2 mb-3">
              <a href="tel:+18007069680" className="text-sm text-muted-foreground hover:text-primary transition-colors inline-flex items-center gap-1.5">
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" /></svg>
                +1 (800) 706-9680
              </a>
              <a href="mailto:chad@releafa.com" className="text-sm text-muted-foreground hover:text-primary transition-colors inline-flex items-center gap-1.5">
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" /></svg>
                chad@releafa.com
              </a>
              <p className="text-xs text-muted-foreground/70 inline-flex items-center gap-1.5">
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                Mon–Fri 9am–5pm CT
              </p>
            </div>
            {/* Social Links */}
            <div className="flex items-center gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-lg bg-muted/30 border border-border/50 flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary/50 hover:bg-primary/10 transition-all duration-200"
                  aria-label={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Explore */}
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-3">Explore</h3>
            <div className="flex flex-col gap-2">
              <Link href="/dispensaries" className="text-sm text-muted-foreground hover:text-primary transition-colors flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" />Dispensaries</Link>
              <Link href="/strains" className="text-sm text-muted-foreground hover:text-primary transition-colors flex items-center gap-1.5"><CannabisLeafIcon className="w-3.5 h-3.5" />Strains</Link>
              <Link href="/shop" className="text-sm text-muted-foreground hover:text-primary transition-colors flex items-center gap-1.5"><ShoppingCart className="w-3.5 h-3.5" />Shop</Link>
            </div>
          </div>

          {/* Community */}
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-3">Community</h3>
            <div className="flex flex-col gap-2">
              <a href="/community" className="text-sm text-muted-foreground hover:text-primary transition-colors flex items-center gap-1.5"><Users className="w-3.5 h-3.5" />Social Feed</a>
              <a href="/community?tab=groups" className="text-sm text-muted-foreground hover:text-primary transition-colors">Groups</a>
              <a href="/match" className="text-sm text-muted-foreground hover:text-primary transition-colors">Smoke Buddy Finder</a>
            </div>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-3">Resources</h3>
            <div className="flex flex-col gap-2">
              <Link href="/learn" className="text-sm text-muted-foreground hover:text-primary transition-colors flex items-center gap-1.5"><BookOpen className="w-3.5 h-3.5" />Cannabis 101</Link>
              <Link href="/learn?tab=legalization" className="text-sm text-muted-foreground hover:text-primary transition-colors">Legalization Map</Link>
              <Link href="/budtender" className="text-sm text-muted-foreground hover:text-primary transition-colors flex items-center gap-1.5"><Bot className="w-3.5 h-3.5" />Budtender</Link>
              <Link href="/about" className="text-sm text-muted-foreground hover:text-primary transition-colors">About Releafa</Link>
              <Link href="/pricing" className="text-sm text-muted-foreground hover:text-primary transition-colors">For Business</Link>
              <Link href="/claim" className="text-sm text-muted-foreground hover:text-primary transition-colors">Claim Your Dispensary</Link>
              <a href="tel:+18007069680" className="text-sm text-muted-foreground hover:text-primary transition-colors">Call Us: (800) 706-9680</a>
              <a href="mailto:chad@releafa.com" className="text-sm text-muted-foreground hover:text-primary transition-colors">Email Us</a>
              <Link href="/help" className="text-sm text-muted-foreground hover:text-primary transition-colors">Help & Support</Link>
              <Link href="/privacy" className="text-sm text-muted-foreground hover:text-primary transition-colors">Privacy Policy</Link>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-border/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} RELEAFA NETWORK. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link href="/privacy" className="text-xs text-muted-foreground hover:text-primary transition-colors">Privacy Policy</Link>
            <Link href="/terms" className="text-xs text-muted-foreground hover:text-primary transition-colors">Terms of Use</Link>
            <Link href="/help" className="text-xs text-muted-foreground hover:text-primary transition-colors">Help</Link>
            <p className="text-xs text-muted-foreground">Must be 21+</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
